/**
 * Acceso manual "Cómo instalar la app" (Perfil): abre la hoja de instalación. Se oculta si Fermin
 * ya corre instalada. Como el dispositivo ya está registrado, la hoja avisa en iPhone que la app
 * instalada pedirá una re-vinculación (vpp-protocol §8: Safari y la PWA no comparten datos).
 */
import { Smartphone } from 'lucide-react';
import { useState } from 'react';

import { buttonClasses } from '../../components/ui/button';
import { isStandalone } from '../../device/platform';
import { t } from '../../i18n';

import { openInstallGuide } from './variants';

export function InstallLink({ className }: { className?: string }) {
  const [standalone] = useState(() => isStandalone());
  if (standalone) {
    return null;
  }
  return (
    <button
      type="button"
      data-testid="install-link"
      className={buttonClasses({ variant: 'ghost', className })}
      onClick={() => openInstallGuide({ enrolled: true })}
    >
      <Smartphone aria-hidden="true" size={20} />
      {t('install.link')}
    </button>
  );
}
